import { DateEntry } from "lib/resume-scoring/resume-analysis/resume-analyse-types";


export const checkDateStructureConsistent = (startDateEntry: any, endDateEntry: any): boolean => {
    // Handle null or undefined date entries
    if (!startDateEntry || !endDateEntry) return true;
    
    // Handle cases where required properties might be missing
    if (!startDateEntry.identifiedDateFormat || !endDateEntry.identifiedDateFormat) return true;
    
    if(endDateEntry.identifiedDateFormat === "OTHER" || startDateEntry.identifiedDateFormat === "OTHER") return true;
    if((endDateEntry.year === "NA" && endDateEntry.month === "NA" && endDateEntry.day === "NA") || (startDateEntry.year === "NA" && startDateEntry.month==="NA" && startDateEntry.day === "NA")) return true
    if(endDateEntry.showsPresent) return true;
    if (startDateEntry.identifiedDateFormat !== endDateEntry.identifiedDateFormat) {
        return false;
    }
    return true;
}